var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'my-option-item',
    _vm.activeValue == _vm.value ? 'active-item' : '',
    _vm.disabled ? 'disbled-item' : '' ],on:{"click":function($event){$event.stopPropagation();return _vm.handleOptionsClick.apply(null, arguments)}}},[(_vm.$slots.default)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ba41e5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mySelect/MyOption.vue
// module id = null
// module chunks = 